export default __webpack_public_path__ + "static/media/llmIcon.1f6cbf08.svg";